import validator = require('validator');
import { toJS } from "mobx";
import { LText } from "Apps/shared/LText";
import { emailRegexp } from "consts/Checkout";


export function required(message?) {
    return (val) => {
        return !val && (message || `VALID_REQUIRED_MESSAGE`);
    }
}

export function requiredStringOrArray(message?) {

    return (val) => {
        var temp = toJS(val);
        var isValid = false;
        if (Array.isArray(temp)) {
            isValid = temp.length != 0;
        } else {
            isValid = val && val != "";
        }
        return !isValid && (message || `VALID_REQUIRED_MESSAGE`);
    }
}

export function isEmail(message?) {
    return (val) => {
        //const isValid = validator.isEmail(val);
        const isValid = emailRegexp.test(val);
        return !isValid && (message || "VALID_EMAIL_MESSAGE")
    }
}

export function isValid(message?) {

    return (val) => {
        return !val && (message || "you need check this item");
    }
}

export function isMaxCharacter(length, message?) {
    return (val) => {
        return (val.length > length) && (message || `Field cannot be longer than ${length} characters`)
    }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/forms/_validator.ts